export default "__VITE_ASSET__C5Iee9eV__"